import Cookies from "js-cookie";

export function setTokenCookie(token) {
  return Cookies.set("token", token, {
    domain: ["localhost"].includes(document.domain)
      ? document.domain
      : ".241210.com",
  });
}

/**
 * 设置当前项目参数类型
 * @param token
 * @return {*}
 */
export function setEntranceKeyCookie(key = "official_website") {
  return Cookies.set("entranceKey", key, {
    domain: ["localhost"].includes(document.domain)
      ? document.domain
      : ".241210.com",
  });
}
